import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useState, useEffect } from "react";
import "../css/Sidebar.css";
import { FiLogOut } from "react-icons/fi";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

const Sidebar = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 800);

  const [homeDropdownOpen, setHomeDropdownOpen] = useState(false);
  const [aboutDropdownOpen, setAboutDropdownOpen] = useState(false);
  const [projectsDropdownOpen, setProjectsDropdownOpen] = useState(false);
  const [galleryDropdownOpen, setGalleryDropdownOpen] = useState(false);

  const handleLogout = () => {
    logout(() => {
      navigate("/admin-login");
    });
  };

  const toggleSidebar = () => setIsOpen(!isOpen);
  const toggleHomeDropdown = () => setHomeDropdownOpen(!homeDropdownOpen);
  const toggleAboutDropdown = () => setAboutDropdownOpen(!aboutDropdownOpen);
  const toggleProjectsDropdown = () => setProjectsDropdownOpen(!projectsDropdownOpen);
  const toggleGalleryDropdown = () => setGalleryDropdownOpen(!galleryDropdownOpen);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 800;
      setIsMobile(mobile);
      if (!mobile) setIsOpen(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {isMobile && (
        <button className="sidebar-toggle" onClick={toggleSidebar}>
          ☰
        </button>
      )}

      <aside className={`dashboard-sidebar ${isMobile && isOpen ? "open" : ""}`}>
        <div className="sidebar-logo">Adinath Builders</div>
        <nav>
          <ul>
            <li>
              <Link to="/admin/dashboard">Dashboard</Link>
            </li>

            {/* Home Dropdown */}
            <li onClick={toggleHomeDropdown}>
              Home {homeDropdownOpen ? <FaChevronUp /> : <FaChevronDown />}
            </li>
            {homeDropdownOpen && (
              <ul className="dropdown-submenu">
                <li><Link to="/admin/add_banner">Add Banner</Link></li>
                <li><Link to="/admin/add_amenities">Add Amenities</Link></li>
                <li><Link to="/admin/add_videos">Add Videos</Link></li>
              </ul>
            )}

            {/* About Us Dropdown */}
            <li onClick={toggleAboutDropdown}>
              About Us {aboutDropdownOpen ? <FaChevronUp /> : <FaChevronDown />}
            </li>
            {aboutDropdownOpen && (
              <ul className="dropdown-submenu">
                <li><Link to="/admin/top_employees">Top Employees</Link></li>
              </ul>
            )}

            {/* Projects Dropdown */}
            <li onClick={toggleProjectsDropdown}>
              Projects {projectsDropdownOpen ? <FaChevronUp /> : <FaChevronDown />}
            </li>
            {projectsDropdownOpen && (
              <ul className="dropdown-submenu">
                <li><Link to="/admin/running_projects">Running Project</Link></li>
                {/* <li><Link to="/admin/upcoming_projects">Upcoming Projects</Link></li>
                <li><Link to="/admin/completed_projects">Completed Projects</Link></li> */}
              </ul>
            )}

            {/* Gallery Dropdown */}
            <li onClick={toggleGalleryDropdown}>
              Gallery {galleryDropdownOpen ? <FaChevronUp /> : <FaChevronDown />}
            </li>
            {galleryDropdownOpen && (
              <ul className="dropdown-submenu">
                <li><Link to="/admin/add_images">Add Images</Link></li>
              </ul>
            )}

            <li className="logout-btn">
              <button className="sidebar-logout-btn" onClick={handleLogout}>
                <FiLogOut />
                Logout
              </button>
            </li>
          </ul>
        </nav>
      </aside>

      {isMobile && isOpen && (
        <div className="sidebar-overlay" onClick={toggleSidebar}></div>
      )}
    </>
  );
};

export default Sidebar;
